import WelcomeOrgScheduleSlots from '@/screens/WelcomeOrgScheduleSlots';

export default function PrivateWelcomeOrgScheduleSlotsRoute() {
  return <WelcomeOrgScheduleSlots />;
}
